<template>
    <div class="jd-expert--income">
<!--        <div class="jd-block__title">账户记录</div>-->
        <k-row class="table-head  ta-center">
            <k-col span="10">日期</k-col>
            <k-col span="7">类型</k-col>
            <k-col span="7">金额</k-col>
        </k-row>
        <div v-if="getMoneyLog && getMoneyLog.length">
            <k-row v-for="(item,index) in getMoneyLog" :key="index" class="table-body cl-desc ta-center">
                <k-col span="10">{{item.ctime.slice(5,16)}}</k-col>
                <k-col span="7">{{item.type}}</k-col>
                <k-col span="7">{{item.money>0?'+':''}}{{item.money|fen2yuan(2)}}</k-col>
            </k-row>
        </div>
        <div v-else class="k-nodata">暂无数据！</div>
        <div v-if="loading" class="k-nodata"><k-loading size="24px">加载中...</k-loading></div>

        <k-pagination
            v-if="totalPage>1"
            v-model="page"
            :page-count="totalPage"
            mode="simple"
        />
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import {WZ} from "../../../utils/wz.v2"
    export default {
        name: "income-list",
        data() {
            return {
                list        : [{desc : '鉴定收入', money : '100', date : '2020-06-30 10:03:88'}],
                page        : 1,
                pageNum     : 20,
                totalPage   : 1,
                nextPage    : 1,
                finished    : false,
                loading     : false,
            }
        },
        computed : {
            ...mapGetters("jianding", ["getMoneyLog"]),
        },
        methods : {
            ...mapActions("jianding", ["LoadMoneyLog"]),
            async load(page){
                let { pageNum } = this;
                let query = {
                    page                : page,
                    pageNum             : pageNum
                };
                this.loading = true;
                await this.LoadMoneyLog(query).then( ({total, list, page}) => {
                    this.totalPage      = Math.ceil((total||0)/pageNum) || 1;
                    this.nextPage       = page + 1;
                    if(list.length < pageNum){
                        this.finished   = true
                    }
                }).catch(err => {
                    this.$toast(err.message);
                });
                this.loading = false;
            },
            downend(data){
                if(!this.finished && this.nextPage < this.totalPage && !this.loading){
                    this.load(this.nextPage);
                }
            }
        },
        created() {
            if(!this.getMoneyLog.length){
                this.load(1);
            }
            //WZ.onScrollDownEnd(this.downend)
        }
    }
</script>

<style scoped>

</style>